/**
 * Capabilities Module
 * Handles show/hide functionality for capability lists
 */

const Capabilities = {
    
    init() {
        this.bindEvents();
    },

    bindEvents() {
        const showMoreButtons = document.querySelectorAll('.more-capabilities-button');
        
        showMoreButtons.forEach(button => {
            button.addEventListener('click', this.handleShowMore.bind(this));
        });
    },

    handleShowMore(event) {
        const button = event.currentTarget;
        const cardsContainer = button.closest('.capabilities-section_cards');
        const list = cardsContainer.querySelector('ul');
        
        if (!list) return;

        // Toggle expanded state
        const isExpanded = list.classList.contains('is-expanded');
        
        if (isExpanded) {
            list.classList.remove('is-expanded');
            button.textContent = 'Show more';
            button.setAttribute('aria-expanded', 'false');
        } else {
            list.classList.add('is-expanded');
            button.textContent = 'Show less';
            button.setAttribute('aria-expanded', 'true');
            button.style.display = 'none';
        }
    }
};

export default Capabilities;
